import { formatDateWithTime, getSerialFromBarcode } from "../../../shared/utility";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TableLoadingSkeleton from "../../shared/TableLoadingSkeleton";
import TraceableBarcode from "../../controls/TraceableBarcode";
import TraceableLotNumber, {
  getInventoryLotTraceType,
} from "../../controls/TraceableLotNumber";

export default function RemovedWipItemsTableComponent(props) {
  const { loading, values } = props;

  const bodyProductName = (item) => (
    <div>
      {item.wip_product_name || "-"}<br />
      <span className="font-semibold">PLU: {item.plu}</span>
    </div>
  );

  const bodyBarcode = (item) => (
    <TraceableBarcode
      barcode={item.returned_barcode}
      displayValue={item.returned_barcode ? getSerialFromBarcode(item.returned_barcode) : "-"}
    />
  );
  const bodyLotNumber = (item) => (
    <TraceableLotNumber
      lotNumber={item.wip_lot_number}
      traceType={getInventoryLotTraceType(item)}
    />
  );

  const bodyCreatedAt = (item) => {
    if (!item.created_at) return <p>-</p>;
    return <p>{formatDateWithTime(item.created_at)}</p>;
  };

  return (
    <div className="flow-root">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block mb-2 min-w-full py-2 align-middle sm:px-6 lg:px-8 space-y-2">
          <div className="w-full flex">
            <h3 className="text-lg leading-6 font-medium text-gray-900 flex-grow">
              Returned items
            </h3>
          </div>
          {loading ? (
            <TableLoadingSkeleton rows={5} columns={5} />
          ) : (
            <div className="overflow-x-auto card-custom bg-white">
              <DataTable
                value={values.removed_items || []}
                dataKey="id"
                tableStyle={{ minWidth: "48rem" }}
                emptyMessage="No returned items found"
                tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
                cellClassName="p-2 border-1-bottom-gray text-sm"
              >
                <Column
                  header="Product Name"
                  body={bodyProductName}
                  style={{ width: "15%" }}
                />
                <Column
                  header="Lot Number"
                  body={bodyLotNumber}
                  style={{ width: "10%" }}
                />
                <Column
                  header="Date"
                  body={bodyCreatedAt}
                  style={{ width: "10%" }}
                />
                <Column
                  header="Serial"
                  body={bodyBarcode}
                  style={{ width: "10%" }}
                />
                <Column
                  header="Amount"
                  field="amount"
                  align="right"
                  alignHeader="right"
                  style={{ width: "10%", textAlign: "right" }}
                />
              </DataTable>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
